<template>
  <div class="domaine-container">

    <div class="header-container">
      <div class="header">
        <div class="navbar">
          <app-accueil-navbar @toggleMenu="toggleMenuTwo" :open="menuShowed"></app-accueil-navbar>
        </div>

        <div class="image-header">
          <div class="header-content">
            <div class="space"></div>
            <h1>Bonjour nous sommes <br><span>Cyberdine Conseil</span></h1>
            <div class="background-blue">
              <p>L’ambition du groupe CYBERDINE, est simplement d’apporter entière satisfaction à l’ensemble de nos clients,<br>
              de maintenir notre niveau d’exigence avec notre travail...</p>
              <div class="barre-vertical"></div>
            </div>
          </div>
        </div>

        <transition name="size-menu">
          <app-accueil-hamburger v-if="this.menuShowed"></app-accueil-hamburger>
        </transition>

        <transition name="opacity">
          <div class="shadow" v-if="this.menuShowed" @click="toggleMenuTwo"></div>
        </transition>
      </div>

    </div>

    <div class="content flex-column">
      <img src="../../img/decouvrez/antenne.svg" class="antenne" alt="">
      <div class="titre flex-row-space-evenly">
        <div class="image-float">
          <app-image-float>
            <template slot="fond"><img src="../../img/societe/element_graphique_service.svg" alt=""></template>
            <template slot="float-image"><img src="../../img/societe/image_la_societe_ambition.png" alt=""></template>
          </app-image-float>
        </div>
        <div class="texte">
          <div class="green-line"></div>
          <h1>Ambition</h1>
        </div>
      </div>

      <div class="texte-long-container">
        <div class="titre flex-column">
          <div class="sub-title flex-row">
            <div class="green-line"></div>
            <span>La société</span>
          </div>
          <h2>L'ambition du groupe</h2>
        </div>
        <div class="paragraphes">
          <p>
            L’ambition du groupe CYBERDINE, est simplement d’apporter entière satisfaction à l’ensemble de nos clients, de maintenir notre niveau d’exigence avec notre travail, et de perpétuer une structure au sein de laquelle chaque collaborateur se sente à sa place.
            <br>
            <br>
            Il n’existe point de perspective de croissance d’activité chez CYBERDINE sans perspective de croissance de la confiance et du respect de nos partenaires.
            <br>
            <br>
            Notre objectif de construction d’une économie durable est fondé sur la volonté de garantir des prestations à tarifs raisonnés, dans une logique d’expansion qualitative, et non quantitative.
            <br>
            <br>
            La vision de départ reste la même, perfectionner notre savoir-faire pour offrir le meilleur service à nos partenaires.

          </p>
        </div>
      </div>

      <div class="buttons-container flex-row-space-between">
        <div class="left" @click="changeTo('societe')">
          <img src="../../img/domaine_activite/fleche_domaine_dactivite.svg" alt="">
          <p>Description</p>
        </div>
        <div class="center" @click="changeTo('accueil')">
          <img src="../../img/domaine_activite/petite_maison.svg" alt="">
        </div>
        <div class="right" @click="changeTo('societe-philosophie')">
          <p>Philosophie</p>
          <img src="../../img/domaine_activite/fleche_domaine_dactivite.svg" alt="">
        </div>
      </div>
    </div>

    <app-domaine-activite></app-domaine-activite>

    <app-slider-citation></app-slider-citation>

    <app-contact></app-contact>

    <app-footer></app-footer>
  </div>
</template>

<script>
    import {menuBus} from "../../main";

    import Navbar from "./Navbar";
    import Footer from "../Footer";
    import HamburgerMenu from "../accueil/HamburgerMenu";
    import Contact from "../accueil/Contact";
    import DomaineActivite from "../accueil/DomaineActivite";
    import SliderCitation from "./SliderCitation";
    import ImageFloat from "./ImageFloatSociete";

  export default {
      data() {
          return {
              menuShowed: false
          }
      },
      methods: {
          toggleMenuTwo() {
              this.menuShowed = !this.menuShowed;
              if (this.menuShowed) {
                  document.getElementsByTagName('body')[0].classList.add('blocked');
              }
              else {
                  document.getElementsByTagName('body')[0].classList.remove('blocked');
              }
          },
          changeTo(pageName) {
              menuBus.$emit('changePage', pageName);
          }
      },
      mounted() {
          menuBus.$on('changePage', (pageName, idName) => {
              this.menuShowed = false;
          });
      },
    components: {
        'app-accueil-navbar': Navbar,
        'app-footer': Footer,
        'app-contact': Contact,
        'app-accueil-hamburger': HamburgerMenu,
        'app-domaine-activite': DomaineActivite,
        'app-slider-citation': SliderCitation,
        'app-image-float': ImageFloat,
    }
  }
</script>

<style scoped>
  .header-container {
    z-index: 100;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .header {
    position: relative;
    height: 100vh;
    min-height: 600px;
  }
  .navbar {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }

  .image-header {
    position: absolute;
    height: 100vh;
    min-height: 650px;
    width: 100%;

    background: url("../../img/societe/reduct/reduct_en_tete_societe_filtrejpg.jpg") no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .image-header .space {
    height: 200px;
  }
  .image-header .header-content {
    position: absolute;
    left: 150px;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 150px);
    text-align: left;
  }
  .image-header h1 {
    z-index: 10;

    font-size: 100px;
    color: white;
    font-weight: bolder;
    line-height: 0.9;
  }
  .image-header h1 span {
    color: #584d70;
  }
  .image-header p {
    margin: 0;
    color: white;
    font-weight: 300;
    font-size: 30px;
  }
  .background-blue {
    background-color: rgba(22, 33, 57, 0.6);
    padding: 20px;
    width: fit-content;
    position: relative;
  }
  .barre-vertical {
    width: 2px;
    height: calc(100% + 40px);
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #dfe8ff;
  }

  .space {
    height: 0px!important;
  }

  .content {
    position: relative;
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .content * {
    z-index: 10;
  }
  .antenne {
    position: absolute;
    right: -250px;
    bottom: -50px;
    height: 75%;
    z-index: 1;
  }

  .titre {
    height: 800px;
    width: 100%;
  }
  .titre h1 {
    font-size: 100px;
    font-weight: 900;
    color: #584d70;
    margin: 0;
    text-align: left;
  }
  .titre .green-line {
    background-color: #b7e17e;
    height: 10px;
    width: 150px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .image-float {
    height: 80%;
    width: 50%;
  }

  .texte-long-container {
    width: 80%;
    text-align: left;
  }
  .texte-long-container .titre {
    height: auto;
    align-items: flex-start;
  }
  .texte-long-container .green-line {
    height: 7px;
    width: 70px;
    margin-bottom: 0;
  }
  .texte-long-container span {
    color: #b7e17e;
    text-transform: uppercase;
    font-size: 25px;
    margin-left: 20px;
    font-weight: 700;
  }
  .texte-long-container h2 {
    font-size: 65px;
    text-align: left;
    margin: 0;
    font-weight: 900;
    color: #584d70;
  }
  .texte-long-container .paragraphes {
    margin-top: 50px;
    margin-bottom: 20px;
    width: 85%;
  }
  .paragraphes p {
    margin-bottom: 30px;
    font-size: 20px;
    color: #9fa8bd;
    font-weight: 300;
    line-height: 1.5;
  }

  .buttons-container {
    height: 150px;
    width: 90%;

    position: relative;

    margin-bottom: 30px;
  }
  .buttons-container > div {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .buttons-container .left, .buttons-container .right {
    height: 30px;
  }
  .buttons-container .center {
    height: 55px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .buttons-container .right img {
    transform: rotate(180deg);
  }
  .buttons-container img {
    height: 100%;
  }
  .buttons-container p {
    margin: 0 10px;
    color: #584d70;
    font-size: 20px;
    font-weight: 900;
  }

  /* Tablet */
  @media (max-width: 1300px) {
    .image-header h1 {
      font-size: 60px;
    }
    .header-content {
      left: 70px!important;
    }
  }
  @media (max-width: 1000px) {
    .content > .titre {
      flex-direction: column;
    }
    .content > .titre > * {
      width: 100%;
    }
    .image-float {
      height: 80%;
      width: 50%;
      max-height: 640px;
      max-width: 625px!important;
    }
    .titre > .texte {
      margin-left: 100px;
      margin-bottom: 50px;
    }
  }

  /* Mobile */
  @media (max-width: 800px) {
    .image-header h1 {
      font-size: 35px;
    }
    .image-header p {
      font-size: 15px;
    }
    .header-content {
      left: 50px!important;
    }
    .space {
      height: 100px!important;
    }
  }
  @media (max-width: 600px) {
    .content h1 {
      font-size: 70px!important;
    }
    .content h2 {
      font-size: 40px!important;
    }
    .sub-title span {
      font-size: 18px;
    }
    .sub-title .green-line {
      width: 40px;
      height: 5px;
    }
    .titre > .texte {
      margin-left: 50px;
      margin-bottom: 50px;
    }
  }
  @media (max-width: 550px) {
    .buttons-container p {
      display: none;
    }
  }
  @media (max-width: 500px) {
    .content h1 {
      font-size: 50px!important;
    }
    .content h2 {
      font-size: 30px!important;
    }
    .sub-title span {
      font-size: 13px;
    }
    .sub-title .green-line {
      width: 30px;
      height: 4px;
    }
  }

  .size-menu-enter-active,
  .size-menu-leave-active {
    transition: all 0.5s;
    max-height: 500px!important;
  }
  .size-menu-enter,
  .size-menu-leave-to
  {
    opacity: 0;
    max-height: 0px!important;
  }

  .shadow {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 60;
    position: fixed;
  }

  .opacity-enter-active,
  .opacity-leave-active {
    transition: all 0.5s;
  }
  .opacity-enter,
  .opacity-leave-to
  {
    opacity: 0;
  }

  @media (min-width: 1100px) {
    .shadow {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/societe/SocieteAmbition.vue